import React from 'react';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Typography,
} from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { useChatSidebarLayout } from 'contexts/ChatSidebarLayoutContext';
import { UNIFIED_LIST_ORDER, type UnifiedListKind } from 'utils/chat-sidebar-unified-statuses';

const STATUS_LABEL: Record<UnifiedListKind, string> = {
  allConversations: 'sidebar.nav.views.allConversationsRow',
  awaitingReply: 'sidebar.nav.views.awaitingReply',
  unassigned: 'sidebar.nav.views.unassignedPendingAssign',
  awaitingCustomer: 'sidebar.nav.views.awaitingCustomerShort',
  firstReply: 'sidebar.nav.views.firstReply',
  reminder: 'sidebar.nav.views.reminderByDate',
  completed: 'sidebar.nav.views.completedArchive',
};

const ManageChatSidebarViewsDialog: React.FC = () => {
  const intl = useIntl();
  const { manageViewsOpen, setManageViewsOpen, statusVisibility, patchStatusVisibility, scope } =
    useChatSidebarLayout();
  const scopeTabLabel = intl.formatMessage({ id: `sidebar.nav.chatScopeTabs.short.${scope}` });

  return (
    <Dialog open={manageViewsOpen} onClose={() => setManageViewsOpen(false)} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontSize: '1rem', fontWeight: 600 }}>
        <FormattedMessage id="sidebar.nav.manageViews.title" />
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.75, fontSize: '0.8125rem' }}>
          <FormattedMessage id="sidebar.nav.manageViews.subtitleStatuses" />
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1.5, fontSize: '0.75rem' }}>
          <FormattedMessage id="sidebar.nav.manageViews.subtitleScopeOnly" values={{ tab: scopeTabLabel }} />
        </Typography>
        <FormGroup>
          {UNIFIED_LIST_ORDER.map((kind) => {
            const key = kind === 'allConversations' ? 'allConversations' : kind;
            return (
              <FormControlLabel
                key={kind}
                control={
                  <Checkbox
                    size="small"
                    checked={statusVisibility.statusRows[key] !== false}
                    onChange={(_, checked) => patchStatusVisibility({ [key]: checked })}
                  />
                }
                label={
                  <Typography variant="body2" sx={{ fontSize: '0.8125rem' }}>
                    <FormattedMessage id={STATUS_LABEL[kind]} />
                  </Typography>
                }
              />
            );
          })}
        </FormGroup>
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 2 }}>
        <Button onClick={() => setManageViewsOpen(false)} variant="contained" color="primary" size="small">
          <FormattedMessage id="sidebar.nav.manageViews.close" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ManageChatSidebarViewsDialog;
